import { Injectable } from '@angular/core'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'
import { environment } from '@env/environment'
import { IChatMessage } from '@app/support-module/core/types'

export interface IClientChatMessagesResponse {
  data: IChatMessage[]
  total_count: number
}

@Injectable({ providedIn: 'root' })
export class GetClientChatMessagesQuery {
  constructor(private httpClient: HttpClient) {}

  call(organizationId: number, page = 1, perPage = 50): Observable<IClientChatMessagesResponse> {
    const url = `${environment.api.app}/help_desk/client/organizations/${organizationId}/chat/messages`
    const params = new HttpParams().set('page', page).set('per_page', perPage)
    return this.httpClient.get<IClientChatMessagesResponse>(url, { params })
  }
}
